import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import axios from "axios";

const TrendingGymSlice = createSlice({
  name: "TrendingGym",

  initialState: {
    trendingGymData: [],
    isLoading: true,
    isError: false,
  },

  reducers: {
    fetchTrendingGymStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchTrendingGymSuccess: (state, action) => {
      state.isLoading = false;
      state.trendingGymData = action.payload;
    },
    fetchTrendingGymFailure: (state, action) => {
      state.isLoading = false;
      state.isError = action.payload;
    },
  },
});

export const {
  fetchTrendingGymStart,
  fetchTrendingGymSuccess,
  fetchTrendingGymFailure,
} = TrendingGymSlice.actions;

export const fetchTrendingGym = () => async (dispatch, getState) => {
  const { TrendingGym } = getState();
  if (TrendingGym.trendingGymData.length > 0) {
    return;
  }
  dispatch(fetchTrendingGymStart());

  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchTrendingGymSuccess(response.data.trending_list || []));
  } catch (error) {
    dispatch(fetchTrendingGymFailure(error));
  }
};

export default TrendingGymSlice.reducer;
